import { defineStyleConfig } from '@chakra-ui/react'

const Button = defineStyleConfig({
    // The styles all button have in common
    baseStyle: {
    },
    variants: {
    }
});

export default Button;